import mutations from './collection/mutations';
import actions from './collection/actions';
import getters from './collection/getters';

const collection = {
  namespaced: true,
  state: {
    items: [],
    pagination: {
      page: 1,
    },
    isLoading: false,
  },
  mutations,
  actions,
  getters,
};

export default collection;
